export default "__VITE_ASSET__AsTWzBEy__"